// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"CommonLoading_componentStyle__Pg0Tg","loader":"CommonLoading_loader__hiJcp","loading":"CommonLoading_loading__pJ326"};